// @flow

import React, {Component} from 'react'
import {map, prepend, filter} from 'ramda'

import GoCheck from 'react-icons/lib/go/check'
import Flag from '@/elements/flag'

import './country-select.css'
import type {Language} from '../types'
import {connect} from 'react-redux'
import {appSelectors} from '@/store'

type Props = {
  l: Language,
  availableCountries: Array<any>,
  selected: string,
  allOption: boolean,
  onChange: (string) => void,
}

const buildOption = (countryConfig) => {
  if (typeof countryConfig === 'string') {
    return ({
      key: countryConfig,
      value: countryConfig,
      flag: countryConfig,
    })
  }
  return ({
    key: countryConfig.code,
    value: countryConfig.language,
    flag: countryConfig.flagCode,
  })
}

const buildOptions = (countries, allOption, l) => {
  const options = map(buildOption, countries)
  if (allOption) return prepend({key: 'all', value: l('All countries'), flag: ''}, options)
  else return options
}

const getSelectedCountry = (countries, code) => {
  if (countries.length === 0 || typeof countries[0] === 'string') {
    return {code: code,
      language: code,
      flagCode: code,
    }
  }
  const defaultCountry = {
    code: 'GB',
    language: 'English',
    flagCode: 'EN',
  }
  const selectedCountry = filter((countryObj) => {
    return countryObj.code === code
  }, countries)
  // sending default language selection as GB if in case api returns the languageCode which is not in list.
  return selectedCountry[0] || defaultCountry
}

class RawCountrySelect extends Component<Props, *> {
  constructor (props: Props) {
    super(props)

    this.state = {
      showList: false,
      selected: props.selected,
    }
  }

  renderOption = ({key, value, flag}: {key: string, value: string, flag: string}) =>
    <li
      key={key}
      onMouseDown={() => {
        this.setState({
          selected: key,
          showList: false,
        })
        this.props.onChange(key)
      }}
    >
      <div className="spacer">
        {this.state.selected === key
          ? <GoCheck style={{marginLeft: '5px'}} />
          : null
        }
      </div>
      {key === 'all' ? null : <Flag code={flag} />}
      <span>{value}</span>
    </li>

  dropdownClassName = () => {
    const base = 'country-select dropdown'
    return this.state.showList
      ? base + ' open'
      : base
  }

  render = () => {
    const selectedCountry = getSelectedCountry(this.props.availableCountries, this.state.selected)
    return (
      <div
        style={{
          display: 'inline-block',
        }}
        className={this.dropdownClassName()}
      >
        <button
          className="btn btn-default dropdown-toggle"
          type="button"
          onClick={() => {
            this.setState((prevState) => ({
              showList: !prevState.showList,
            }))
          }}
          onBlur={() => {
            this.setState({
              showList: false,
            })
          }}
        >
          {this.state.selected === 'all'
            ? this.props.l('All countries')
            : <span><Flag code={selectedCountry.flagCode}/> {selectedCountry.language}</span>
          }
          <span
            style={{
              marginLeft: '6px',
            }}
            className="caret"
          >
          </span>
        </button>
        <ul
          className="dropdown-menu"
        >
          {map(
            this.renderOption,
            buildOptions(
              this.props.availableCountries,
              this.props.allOption,
              this.props.l,
            )
          )}
        </ul>
      </div>
    )
  }

  componentWillReceiveProps = (nextProps: Props) => {
    if (this.props.selected !== nextProps.selected) {
      this.setState({selected: nextProps.selected})
    }
  }
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
)(RawCountrySelect)



// WEBPACK FOOTER //
// ./src/controls/country-select.js